import styled from 'styled-components'
import BaseProductCard from 'components/ProductCard'
import Fonts from 'components/base-ui/Fonts'
import { weight } from 'components/base-ui/Fonts'

const ProductListWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  column-gap: 4%;
  row-gap: 15px;
  padding-top: 15px;

  .product-name {
    font-size: 15px !important;
  }
  .add-to-cart-icon {
    font-size: 18px;
  }
`

const ExcludedProductSection = styled.div<{ isShowOnlyExcludedProducts: boolean }>`
  display: flex;
  flex-direction: column;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 15px;
  height: 100%;
  ${({ isShowOnlyExcludedProducts }) =>
    isShowOnlyExcludedProducts
      ? ` background: none; 
          padding-top: 0;`
      : `background: #f88d2a1a; 
        padding-top: 15px;`}
`

const ProductCard = styled(BaseProductCard)`
  padding: 0px;
  width: 48%;
`

const Title = styled(Fonts.H3)`
  font-size: 20px;
  font-weight: ${weight.bold};
`

const SubTitle = styled(Title)`
  font-size: 14px;
`

const ProductListSection = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 25px;
  padding: 25px 0;
`

const Divider = styled.div`
  width: 100%;
  border-top: 1px solid #e0e0e0;
`

export { ProductListWrapper, ExcludedProductSection, ProductCard, Title, SubTitle, ProductListSection, Divider }
